<div class="grid grid-cols-3 my-4">
  <!-- Phone Numbers -->
  <div>
    <h3>Phone Numbers</h3>
    @for (phone of customer.phones | sortCustomerPhones; track phone) {
      <div data-test="phone-number" class="flex items-center gap-2">
        <h4>{{ phone.phoneType }}:</h4>
        <span> {{ phone.phoneNumber | phone }}</span>
      </div>
    }
    <div>
      <div class="flex items-center gap-2">
        <h4>Call List:</h4>
        <span>{{ customer.callList | yesNo }}</span>
      </div>
    </div>
    <div>
      <div class="flex items-center gap-2">
        <h4>Text List:</h4>
        <span>{{ customer.textList | yesNo }}</span>
      </div>
    </div>
  </div>

  <!-- Full Name -->
  <div>
    @if (!isCompanyOrReseller) {
      <h3>Full Name</h3>
    }
    @if (isCompanyOrReseller) {
      <h3>Name</h3>
    }
    <div>
      <span data-test="customer-name">
        {{
          isCompanyOrReseller
            ? (customer | customerName | titlecase)
            : (customer | customerName | namecase)
        }}
      </span>
    </div>
  </div>

  <!-- Mailing Address -->
  <div class="flex flex-col">
    <div>
      <h3>Mailing Address</h3>
    </div>

    <!-- Mailing Addres section -->
    <div>
      <div class="flex relative items-center gap-2">
        <ss-stx-shared-address-verification-check
          [addressStatus]="customer.addressVerifiedStatus"
        ></ss-stx-shared-address-verification-check>
        <span class="text-sm">{{
          customer.addressVerifyDate
            ? (customer.addressVerifyDate | date: 'MM/dd/yyyy')
            : ('' | nullFormatter)
        }}</span>
      </div>
      <span data-test="mailing-address" style="line-height: 1.4">
        {{ customer.address.addressLine1 | titlecase | addressLineFormat }}
        {{ customer.address.addressLine2 | titlecase | addressLineFormat
        }}<br />
        {{ customer.address.city | namecase }}, {{ customer.address.state }}
        {{ customer.address.zipcode }}
      </span>
      <div class="flex items-center gap-2">
        <h4>Mailing List:</h4>
        <span>{{ customer.mailingList | yesNo }}</span>
      </div>
    </div>

    <br />
    <!-- Email Section -->
    <h3 class="page-wrapper__section__content-column-spacing">Email Address</h3>
    <span data-test="email-address">{{ customer.emailAddress }}</span>
    @if (can('read', 'marketing:email-list:member')) {
      <div class="flex items-center gap-2">
        <h4>Email List:</h4>
        <span>{{ emailList$ | async | yesNo }}</span>
      </div>
    }
  </div>
</div>
